import { FONT as font } from 'global/configs/theme/defaults'

export default {
  tooltip: {
    lineHeight: font.lineheight.regular,
    fontSize: font.size.small,
    fontWeight: font.weight.regular
  }
}
